import ManualShow from './ManualShow'
export {ManualShow}
export default ManualShow
